import { Blueprint, Handshake, ArrowsLeftRight } from "@phosphor-icons/react";
import { Container, Overline, SectionTitle } from "./Section";

const ICONS = [Blueprint, Handshake, ArrowsLeftRight];

export default function Modes({ t }) {
  const m = t.modes;
  return (
    <section id="modes" className="py-24 lg:py-32 bg-white">
      <Container>
        <Overline testid="modes-overline">{m.overline}</Overline>
        <SectionTitle testid="modes-title" className="max-w-2xl mb-16">{m.title}</SectionTitle>
        <div className="grid md:grid-cols-3 gap-8">
          {m.items.map((item, i) => {
            const Icon = ICONS[i];
            const main = i === 2;
            return (
              <div
                key={item.name}
                data-testid={`mode-card-${i}`}
                className={`p-8 lg:p-10 flex flex-col border-t-2 ${
                  main ? "bg-[#0B1B3D] text-white border-[#0B1B3D]" : "bg-[#F4F5F7] text-[#0B1B3D] border-[#0B1B3D]"
                }`}
              >
                <div className="flex items-center justify-between mb-10">
                  <Icon size={30} weight="light" className={main ? "text-white" : "text-[#0B1B3D]"} />
                  {main && (
                    <span className="text-[11px] font-semibold tracking-[0.2em] uppercase text-[#8FA1B5]" data-testid="mode-highlight">
                      {m.highlight}
                    </span>
                  )}
                </div>
                <h3 className="font-heading text-lg font-bold tracking-tight mb-4">{item.name}</h3>
                <p className={`text-base leading-relaxed ${main ? "text-white/70" : "text-[#5A6B7C]"}`}>{item.text}</p>
              </div>
            );
          })}
        </div>
      </Container>
    </section>
  );
}
